import { ErrorMessage } from '@hookform/error-message';
import ReactButton from 'components/Buttons/ReactButton';
import { ErrorFormMessage } from 'components/ErrorFormMessage';
import TelephoneMask from 'components/Inputs/TelephoneMask';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Col, Form, Input, Row } from 'reactstrap';
import CustomFieldsInputsForm from 'views/CRM/shared/components/CustomFieldsInputsForm';
import { formatCustomFieldsToSubmit } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { removeMaskSpecialCharacters } from 'views/CRM/shared/utils/phoneNumberHelpers';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';

import ContactService from '../../../../../Contact/services/contactService';
import { FlexController } from 'components/FlexControllerInput';

const AddContactToAccountForm = ({
  isOpen,
  setIsOpen,
  recordTypeId,
  accountId,
  onAddedContact
}) => {
  const { control, errors, setValue, handleSubmit, watch } = useForm();

  const { customFields, getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.CONTACT,
    recordTypeId
  );

  useEffect(() => {
    if (isOpen) getCustomFields();
  }, [isOpen, getCustomFields]);

  const onSubmit = (data) => {
    data.phone = data.phone_number;
    data.phone = removeMaskSpecialCharacters(data.phone);
    data.accountId = accountId;

    const dataDTO = formatCustomFieldsToSubmit(data, customFields);

    ContactService.createContact(recordTypeId, dataDTO)
      .then(() => {
        toast.success('Contato criado com successo');
        onAddedContact();
        setIsOpen(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || 'Erro ao criar contato');
      });
  };

  return (
    <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col className="mb-3" sm="6">
          <label className="form-control-label text-capitalize">Nome*</label>
          <Controller
            render={(props) => (
              <Input
                valueController={setValue}
                value={props.value}
                onChange={props.onChange}
                type="text"
                placeholder="Nome"
              />
            )}
            control={control}
            defaultValue=""
            rules={{ required: 'Campo obrigatório' }}
            name="name"
          />
          <ErrorMessage
            errors={errors}
            name="name"
            render={({ message }) => ErrorFormMessage({ message })}
          />
        </Col>
        <Col className="mb-3">
          <FlexController
            type="phone"
            label="Telefone"
            name="phone"
            disabled={false}
            watch={watch}
            value={watch('phone')}
            control={control}
            errors={errors}
            rules={{ required: 'Campo obrigatório' }}
            valueController={(fieldName, value) => {
              setValue(fieldName, value);
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col className="mb-3" sm="6">
          <label className="form-control-label text-capitalize">Email</label>
          <Controller
            render={(props) => (
              <Input
                name="email"
                valueController={setValue}
                value={props.value}
                onChange={props.onChange}
                placeholder="seu-email@mail.com"
              />
            )}
            control={control}
            defaultValue=""
            rules={{
              validate: (value) => {
                if (!value) return true;
                const emailRegex =
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
                return emailRegex.test(value) || 'Email com formato incorreto';
              }
            }}
            name="email"
          />
          <ErrorMessage
            errors={errors}
            name="email"
            render={({ message }) => ErrorFormMessage({ message })}
          />
        </Col>

        <CustomFieldsInputsForm
          fields={customFields}
          control={control}
          errors={errors}
          setValue={setValue}
          Controller={Controller}
          watch={watch}
        />
      </Row>
      <hr />

      <ReactButton btnColor="confirmation" type="submit">
        Salvar
      </ReactButton>

      <ReactButton btnColor="cancelation" onClick={() => setIsOpen(false)}>
        Cancelar
      </ReactButton>
    </Form>
  );
};

export default AddContactToAccountForm;
